import { UseMutationOptions, useMutation, useQueryClient } from '@tanstack/react-query';
import { fetchCampaignCustomFields } from 'api/campaigns';
import { campaignQueryKeys } from 'queries/campaign-query-keys';
import { CustomField } from 'types/domain';

const useSelectedCampaignCustomFields = ({
    onSuccess,
    ...options
}: Pick<UseMutationOptions<CustomField[], Error, number>, 'onSuccess'>) => {
    const queryClient = useQueryClient();

    const { data: customFields, mutate: selectCampaign } = useMutation({
        mutationFn: (campaignId: number) => {
            const data = queryClient.getQueryData<CustomField[]>(
                campaignQueryKeys.customFields(campaignId),
            );

            if (data) {
                return Promise.resolve(data);
            }

            return fetchCampaignCustomFields(campaignId);
        },
        onSuccess: (customFields, campaignId, context) => {
            queryClient.setQueryData(campaignQueryKeys.customFields(campaignId), customFields);
            onSuccess?.(customFields, campaignId, context);
        },
        ...options,
    });

    return { customFields, selectCampaign };
};

export { useSelectedCampaignCustomFields };
